module.exports = new __parcel__URL__("flamingo.2d59f884.svg").toString();